import { config } from "../../utils/constants";
import axios from "axios";
import { getCookie, isLiferayEnv } from "../../utils/util";
import { oAuthRequest } from "../../utils/request";

export const getFilesFromFolder = (folderName) => {

  const requestConfig = {
    url: `${config.common}document/${folderName}`,
    method: "get",
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return axios.request(requestConfig);
};

export function getTokenJson() {
  if (getCookie("epicToken")) {
    let epicTokenStr = getCookie("epicToken").value;
    return JSON.parse(decodeURIComponent(epicTokenStr));
  }
  return null;
}

export const showRelationInMr = () => {
  let showRelation = true;
  let epicTokenJson = getTokenJson();
  if (epicTokenJson) {
    let { wprEptId, wprId } = epicTokenJson;
    if (wprEptId === wprId) {
      showRelation = false;
    }
  }
  return showRelation;
};

export function getMoblieNumberLoginUser() {
  let epicTokenJson = getTokenJson();
  if (epicTokenJson) {
    let mobileNumber = epicTokenJson.patmobileno;
    return mobileNumber.replaceAll("+", " ");
  }
  return "";
}

export function getUserMrn() {
  let epicTokenJson = getTokenJson();
  if (epicTokenJson) {
    return epicTokenJson.mrn;
  }
  return "";
}

function decodeEmail(encodedEmail) {
  return decodeURIComponent(encodedEmail);
}

export function getUserEmail() {
  let epicTokenJson = getTokenJson();
  // console.log("epic json token blood donation", epicTokenJson);
  if (epicTokenJson) {
    return decodeEmail(epicTokenJson?.useremail);
  }
  return "";
}

export function getUserNameMyChart() {
  let epicTokenJson = getTokenJson();
  // console.log("epic json token blood donation", epicTokenJson);
  if (epicTokenJson) {
    return decodeEmail(epicTokenJson?.sysUserId);
  }
  return "";
}

export function getCountryData() {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.common}getCountryData`,
    method: "get"
  };

  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
}